import React from 'react'

import EnterpriseRiskHero from './EnterpriseRisk/EnterpriseRiskHero'
import EnterpriseRiskSection from './EnterpriseRisk/EnterpriseRiskSection'
import EnterpriseRiskTrust from './EnterpriseRisk/EnterpriseRiskTrust'
import Footer from '../Footer/Footer'

function EnterpriseRiskManagement() {
    return (
        <div>
          <EnterpriseRiskHero/>
          <EnterpriseRiskSection/>
          <EnterpriseRiskTrust/>
          <Footer/>
        </div>
    )
}

export default EnterpriseRiskManagement
